import { isApp } from './utils';
import { wmdaCodeMap } from '../pages/autarky/wmdaCode';
import { getSearchString } from './utils/libs/helper';
import { locStorage } from './utils/libs/locStorage';

interface ObjInfo {
    [propname: string]: any;
}

const wmdaReport = {

    setWmdaReport(obj: ObjInfo = {}) {
        // WMDA 手动埋点
        const { isSupport, get } = locStorage;
        const fromC = getSearchString(window.location.search, 'from');
        let ab_test = '{}';
        if (isSupport() && get('ab_test')) {
            ab_test = get('ab_test') || '{}';
        }
        Object.assign(obj, { projectType: 'CHONGGOU', fromC,  'ab_test': '', ...JSON.parse(ab_test)});
        if (window.WMDA_REPORT) {
            window.WMDA_REPORT('custom', obj);
        }
    }
};
export default wmdaReport;

let _handler;
// 事件监听 兼容
const addEvent = (function (): any {
    if (window.addEventListener) {
        return (el, sType, fn) => {
            el.addEventListener(sType, fn, false);
        };
    } else if (window.attachEvent) {
        return (el, sType, fn) => {
            el.attachEvent('on' + sType, fn);
        };
    }
})();
const removeEvent = (function (): any {
    if (window.removeEventListener) {
        return (el, sType, fn) => {
            el.removeEventListener(sType, fn, false);
        };
    } else if (window.detachEvent) {
        return (el, sType, fn) => {
            el.detachEvent('on' + sType, fn);
        };
    }
})();

export const removeEventFunc = () => {
    let visibilitychange;
    let webHidden = document as any;
    if (typeof document.hidden !== 'undefined') {
        visibilitychange = 'visibilitychange';
    } else if (typeof webHidden !== 'undefined') {
        visibilitychange = 'webkitvisibilitychange';
    }
    removeEvent(document, visibilitychange, _handler);
};

/**
 * @deprecated 页面压入后台或者从后台提上来的事件兼容
 */
export const visibilityChange = function (resume, pause) {
    let hidden: string, visibilitychange, tag, state;
    let webHidden = document as any;
    if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden';
        visibilitychange = 'visibilitychange';
        state = 'visibilityState';
    } else if (typeof webHidden !== 'undefined') {
        hidden = 'webkitHidden';
        visibilitychange = 'webkitvisibilitychange';
        state = 'webkitVisibilityState';
    }

    _handler =  () => {
        tag = document[hidden];
        if (document[state] === 'visible' || !tag) {
            resume && resume();
        } else {
            pause && pause();
        }
    };

    addEvent(document, visibilitychange, _handler);
};

/*
* 通过页面的地址， 到map里找到上报的code
* 去掉地址栏?后面的字符串和前面的#   Y
* map里面如果没有hash， 正则取/xx/xx/xx/xx 或者/xx/xx/xx 或者 /xx/xx 或者 /xx Y
* 或者匹配/auth开头/ssss/aaaa/withdraw结尾   aaa是creditId , 匹配去掉
* /auth/face   在h5 和app 分别加载不同的组件要分别上报
*/
export const getUrlCode = (urlhash) => {
    let hash = urlhash.replace(/\?.*/g, '').replace(/^#/g, '');
    let urlMatch: string;
    let sendObj: any;
    let i = 4;
    let specialUrl = '/auth/face';
    if ((/\/withdraw$/).test(hash) && (/^\/auth/).test(hash)) {
        let sp_reg = /\/\w+(?=\/withdraw$)/;
        hash = hash.replace(sp_reg, '');
        if (typeof wmdaCodeMap[hash] === 'object') {
            return wmdaCodeMap[hash];
        }

    } else {
        while (i >= 1) {
            urlMatch = getSendObj(hash, i);

            if (i === 2 && urlMatch === specialUrl) {
                if (isApp()) {
                    return wmdaCodeMap[specialUrl].app;
                } else {
                    return wmdaCodeMap[specialUrl].h5;
                }
            }

            if (typeof wmdaCodeMap[urlMatch] === 'object') {
                sendObj = wmdaCodeMap[urlMatch];
                break;
            } else {
                i--;
            }
        }
    }
    return sendObj;
};

// 传入str 匹配n个 /xxx
const getSendObj = (hash: any, n: number) => {
    let urlMatch: any;
    const reg = new RegExp(`(\\/\\w+){${n}}`, 'g');
    urlMatch = hash.match(reg);
    if (urlMatch !== null) {
        urlMatch = urlMatch[0];
    }
    return urlMatch;
};

function repeatFunc(func,delay){
    let startTime = 0;
    let hash = '';
    // tslint:disable-next-line: only-arrow-functions
    return function(args: any) {
        let curTime = Date.now();
        if (curTime - startTime > delay || hash !== args) {
            startTime = Date.now();
            hash = args;
            return func.apply(null, [args]);
        }else {
            startTime = Date.now();
            hash = args;
            // tslint:disable-next-line: only-arrow-functions
            return function() {};
        }
    };
}

const _getUrlCode = repeatFunc(getUrlCode, 1000);

export const sendWmda = (hash: string, period = -1, obj = {}) => {
    const _data = _getUrlCode(hash);
    if (_data && _data.eventId && _data.eventName) {
        wmdaReport.setWmdaReport({
            event_id: _data.eventId,
            event_name: _data.eventName,
            period,
            ...obj
        });
    }
}

/**
 * 按钮等点击操作，冒泡到document,识别dom元素上的data-custom-click， data-event-id参数上报
 */
(function () {
    addEvent(document, 'click', function (e) {
        let i = 0;
        let el = e.target;
        let tag_name = '';
        try {
            while (el && (tag_name = el.tagName) && i < 5) {
                if (findAttri(el)) {
                    let eventId = el.getAttribute('data-event-id');
                    let clickName = el.getAttribute('data-custom-click');
                    let eventOther = el.getAttribute('data-event-obj'); // 额外的参数对象
                    let eventData = {
                        event_id: eventId,
                        event_name: clickName,
                    };

                    if (typeof eventOther !== undefined){
                        eventOther = JSON.parse(eventOther);
                        Object.assign(eventData, eventOther);
                    }
                    
                    wmdaReport.setWmdaReport(eventData);
                    break;
                } else if (tag_name.toUpperCase() === 'BODY' || tag_name.toUpperCase() === 'HTML') break;
                el = el.parentNode;
                i++;
            }
        } catch (e) {
            console.log(e);
        }
    });

    function findAttri(el: any) {
        if (el.getAttribute('data-custom-click') && el.getAttribute('data-event-id')) {
            return true;
        }
        return false;
    }

})();


